import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

export function useFetch(url, deps = []) {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const fetch = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    setError(null);
    try {
      const { data: res } = await api.get(url);
      setData(res);
    } catch (err) {
      setError(err?.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  useEffect(() => { fetch(); }, [fetch, ...deps]);

  return { data, loading, error, refetch: fetch };
}

// ─── useScrollRestore ─────────────────────────────────────────────────────────
// Saves .page-body scroll when a modal opens, restores after data reloads.
// saveScroll()    — call on row click (modal open)
// restoreScroll() — call on modal close (marks restore as pending)
// applyScroll()   — call inside useEffect([data]) so it fires after re-render
export function useScrollRestore(storageKey) {
  const pendingKey = storageKey + '_pending';

  const saveScroll = () => {
    const el = document.querySelector('.page-body');
    if (el) sessionStorage.setItem(storageKey, String(el.scrollTop));
  };

  const restoreScroll = () => {
    if (sessionStorage.getItem(storageKey) != null) {
      sessionStorage.setItem(pendingKey, '1');
    }
  };

  const applyScroll = () => {
    if (!sessionStorage.getItem(pendingKey)) return;
    sessionStorage.removeItem(pendingKey);
    const saved = sessionStorage.getItem(storageKey);
    if (saved == null) return;
    const target = parseInt(saved, 10);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const el = document.querySelector('.page-body');
      if (el) {
        el.scrollTop = target;
        sessionStorage.removeItem(storageKey);
      }
    }));
  };

  return { saveScroll, restoreScroll, applyScroll };
}
